import React from 'react';

import Moment from 'moment'
import momentLocalizer from 'react-widgets-moment';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import 'moment/locale/es';
import 'react-widgets/dist/css/react-widgets.css';
import '../../assets/css/date-picker-styles.css';

Moment.locale('es')
momentLocalizer()

class CustomDatePicker extends React.Component {

    render() {
        return (
            <div style={{ flex: "50%", paddingLeft: "5%", paddingRight: "5%", width: "100%", paddingTop: 7.5, paddingBottom: 7.5, ...this.props.style }}
                key={"customDatePicker." + this.props.currentDate}>

                <p className="card-category" style={{ marginBottom: 5, fontSize: 10, textTransform: "uppercase" }}>
                    <b>{this.props.title}</b>
                </p>

                <div style={{ paddingLeft: "0%", paddingRight: "0%" }}>
                    <DateTimePicker defaultValue={this.props.currentDate} style={{ ...this.props.inputStyle }}
                        onChange={(newDate) => { console.log(newDate); if (this.props.onChange !== undefined) { this.props.onChange(newDate); } }} />
                </div>
            </div>
        );
    }
}

export default CustomDatePicker;